module.exports = __webpack_public_path__ + "static/media/facebook.987694f9.svg";